var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { urlAPI } from '../shared/api';
function sprintGame() {
    var dictStorage = JSON.parse(localStorage.getItem('rsteam17-dictionary'));
    var chooseLevelBtns = document.querySelector('.choose-level').children;
    var sprintWords = [];
    var sprintResults = [];
    var sprintScore = 0;
    var setPage = 1;
    var aContext = new AudioContext();
    var audio;
    var showWordInitlVal = 0;
    var chooseLvlGroup;
    var startFromVocabulary = false;
    var timerId;
    function getWordsGroup(group, page) {
        return __awaiter(this, void 0, void 0, function () {
            var words;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(urlAPI, "/words?group=").concat(group, "&page=").concat(page - 1))
                            .then(function (res) { return res.json(); })
                            .then(function (data) {
                            sprintWords.push.apply(sprintWords, data);
                        })
                            .catch(function (error) {
                            console.log('Something went wrong', error.message);
                        })];
                    case 1:
                        words = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var gameStartPage = document.querySelector('.sprint-game-start');
    var gamePlayPage = document.querySelector('.sprint-game-play');
    var lvlBtn = document.querySelector('#lvl-btn');
    var time = document.querySelector('.sprint-game-timer');
    var resultsPage = document.querySelector('.sprint-results-section');
    var timer = function () {
        time.innerHTML = '60';
        var curTime = +time.innerHTML;
        timerId = setInterval(function () {
            if (curTime === 1) {
                showResults();
                clearInterval(timerId);
            }
            curTime--;
            time.innerHTML = '' + curTime;
        }, 1000);
    };
    var showWord = function (idx) {
        console.log('showWordInitlVal', showWordInitlVal);
        if (idx >= sprintWords.length) {
            if (startFromVocabulary) {
                setPage--;
                if (setPage < 1) {
                    clearInterval(timerId);
                    showResults();
                }
                else {
                    getWordsGroup(chooseLvlGroup, setPage);
                }
            }
            else {
                setPage++;
                getWordsGroup(chooseLvlGroup, setPage);
            }
        }
        var sprintWordPlace = document.querySelector('.word-question');
        var answerPlace = document.querySelector('.sprint-translation');
        sprintWordPlace.innerHTML = sprintWords[idx].word;
        var randomAnswer = Math.floor(Math.random() * 2);
        var isTrue = true;
        if (idx + randomAnswer >= sprintWords.length) {
            answerPlace.innerHTML = sprintWords[idx - randomAnswer].wordTranslate;
            if (sprintWords[randomAnswer].wordTranslate !== sprintWords[idx].wordTranslate) {
                isTrue = false;
            }
            else {
                isTrue = true;
            }
        }
        else {
            answerPlace.innerHTML = sprintWords[idx + randomAnswer].wordTranslate;
            if (sprintWords[idx + randomAnswer].wordTranslate !== sprintWords[idx].wordTranslate) {
                isTrue = false;
            }
            else {
                isTrue = true;
            }
        }
        sprintResults.push([sprintWords[idx], isTrue]);
        showWordInitlVal++;
    };
    var trueBtn = document.querySelector('#trueBtn');
    var falseBtn = document.querySelector('#falseBtn');
    var scoreBlock = document.querySelector('.score');
    resultsPage.addEventListener('keypress', function (e) { return console.log(true); });
    function updateScore() {
        var lastFourAnswers = sprintResults.map(function (el) { return [el[1], el[2]]; }).slice(-4);
        if (lastFourAnswers.length === 4 && lastFourAnswers.every(function (arr) { return arr[0] === arr[1]; })) {
            sprintScore += 20;
        }
        else if (sprintResults[sprintResults.length - 1][1] === sprintResults[sprintResults.length - 1][2]) {
            sprintScore += 10;
        }
        scoreBlock.innerHTML = "".concat(sprintScore);
    }
    function getAudioAndPlay(urlSound) {
        fetch("".concat(urlAPI, "/").concat(urlSound))
            .then(function (data) { return data.arrayBuffer(); })
            .then(function (arrayBuffer) { return aContext.decodeAudioData(arrayBuffer); })
            .then(function (decodedAudio) {
            audio = decodedAudio;
            var playSound = aContext.createBufferSource();
            playSound.buffer = audio;
            playSound.connect(aContext.destination);
            playSound.start(aContext.currentTime);
        });
    }
    var showResults = function () {
        resultsPage.classList.toggle('visually-hidden');
        gamePlayPage.classList.toggle('visually-hidden');
        sprintResults.forEach(function (arr) {
            createRow(arr[0], arr[1], arr[2]);
        });
        var resultWords = resultsContainer.children;
        var _loop_1 = function (i) {
            resultWords[i].firstChild.addEventListener('click', function () {
                var src = sprintWords.filter(function (el) {
                    if (el.word === resultWords[i].children[1].innerHTML)
                        return el;
                }).map(function (el) { return el.audio; });
                getAudioAndPlay(src);
            });
        };
        for (var i = 0; i < resultWords.length; i++) {
            _loop_1(i);
        }
        restartBtn.addEventListener('click', restartSprint);
    };
    var resultsContainer = document.querySelector('.sprint-results__container');
    var createRow = function (obj, isTrue, answer) {
        var wordRow = document.createElement('div');
        wordRow.classList.add('sprint-word');
        var volumeIcon = document.createElement('div');
        volumeIcon.classList.add('sprint-icon', 'volume-icon');
        var spelling = document.createElement('p');
        spelling.classList.add('spelling');
        spelling.innerHTML = obj.word;
        var transcription = document.createElement('p');
        transcription.classList.add('transcription');
        transcription.innerHTML = obj.transcription;
        var translation = document.createElement('p');
        translation.classList.add('translation');
        translation.innerHTML = obj.wordTranslate;
        var resultIco = document.createElement('div');
        resultIco.classList.add('sprint-icon');
        if (isTrue === answer) {
            resultIco.classList.add('checkmark');
        }
        else {
            resultIco.classList.add('wrong');
        }
        wordRow.append(volumeIcon);
        wordRow.append(spelling);
        wordRow.append(transcription);
        wordRow.append(translation);
        wordRow.append(resultIco);
        resultsContainer.append(wordRow);
    };
    function startGameOnLvlBtn(group, page) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sprintWords = sprintWords.filter(function (el) { return typeof el === 'boolean'; });
                        return [4 /*yield*/, getWordsGroup(group, page)
                                .then(function (data) {
                                if (lvlBtn.classList.contains('visually-hidden')) {
                                    lvlBtn.classList.toggle('visually-hidden');
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function listenLvlBtns() {
        var _loop_2 = function (i) {
            chooseLevelBtns[i].addEventListener('click', function () {
                chooseLvlGroup = i;
                console.log('выбрана группа ', i, 'страница ', setPage);
                startGameOnLvlBtn(i, setPage);
            });
        };
        for (var i = 0; i < chooseLevelBtns.length; i++) {
            _loop_2(i);
        }
    }
    lvlBtn.addEventListener('click', startPageBtnFn);
    function startPageBtnFn() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(sprintWords.length === 0 || startFromVocabulary)) return [3 /*break*/, 2];
                        setPage = dictStorage.page;
                        startFromVocabulary = true;
                        console.log('игра запущена из словаря, страница ', setPage, 'группа ', dictStorage.group);
                        return [4 /*yield*/, getWordsGroup(+dictStorage.group, setPage)
                                .then(function (res) {
                                timer();
                                showWord(showWordInitlVal);
                                gamePlayPage.classList.toggle('visually-hidden');
                                gameStartPage.classList.toggle('visually-hidden');
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        gamePlayPage.classList.toggle('visually-hidden');
                        gameStartPage.classList.toggle('visually-hidden');
                        timer();
                        showWord(showWordInitlVal);
                        console.log('игра запущена со стартовой страницы, страница ', setPage, 'группа ', chooseLvlGroup);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    trueBtn.addEventListener('click', function () {
        sprintResults[sprintResults.length - 1].push(true);
        updateScore();
        showWord(showWordInitlVal);
    });
    falseBtn.addEventListener('click', function () {
        sprintResults[sprintResults.length - 1].push(false);
        updateScore();
        showWord(showWordInitlVal);
    });
    var restartBtn = document.querySelector('#restart-sprint');
    function restartSprint() {
        sprintWords = [];
        sprintResults = [];
        sprintScore = 0;
        setPage = 1;
        time.innerHTML = '10';
        showWordInitlVal = 0;
        scoreBlock.innerHTML = "".concat(sprintScore);
        while (resultsContainer.firstChild) {
            resultsContainer.removeChild(resultsContainer.firstChild);
        }
        document.querySelector('.choose-level').classList.remove('visually-hidden');
        resultsPage.classList.toggle('visually-hidden');
        gameStartPage.classList.toggle('visually-hidden');
        if (!lvlBtn.classList.contains('visually-hidden')) {
            lvlBtn.classList.toggle('visually-hidden');
        }
    }
    document.addEventListener('keydown', function (e) {
        if (!gameStartPage.classList.contains('visually-hidden')) {
            if (e.code === '1') {
                chooseLvlGroup = 0;
                console.log('выбрана группа ', 0, 'страница ', setPage);
                startGameOnLvlBtn(0, setPage);
            }
            else if (e.code === '2') {
                chooseLvlGroup = 1;
                console.log('выбрана группа ', 1, 'страница ', setPage);
                startGameOnLvlBtn(1, setPage);
            }
            else if (e.code === '3') {
                chooseLvlGroup = 2;
                console.log('выбрана группа ', 2, 'страница ', setPage);
                startGameOnLvlBtn(2, setPage);
            }
            else if (e.code === '4') {
                chooseLvlGroup = 3;
                console.log('выбрана группа ', 3, 'страница ', setPage);
                startGameOnLvlBtn(3, setPage);
            }
            else if (e.code === '5') {
                chooseLvlGroup = 4;
                console.log('выбрана группа ', 4, 'страница ', setPage);
                startGameOnLvlBtn(4, setPage);
            }
            else if (e.code === '6') {
                chooseLvlGroup = 5;
                console.log('выбрана группа ', 5, 'страница ', setPage);
                startGameOnLvlBtn(5, setPage);
            }
            else if (e.code === 'Enter') {
                startPageBtnFn();
            }
        }
        if (!gamePlayPage.classList.contains('visually-hidden')) {
            if (e.code === 'ArrowLeft') {
                sprintResults[sprintResults.length - 1].push(true);
                updateScore();
                showWord(showWordInitlVal);
            }
            else if (e.code === 'ArrowRight') {
                sprintResults[sprintResults.length - 1].push(false);
                updateScore();
                showWord(showWordInitlVal);
            }
        }
        if (!resultsPage.classList.contains('visually-hidden')) {
            if (e.code === 'Enter') {
                restartSprint();
            }
        }
    });
    listenLvlBtns();
}
export { sprintGame };
